class Breakpoint {
    constructor() {
        this.breakpoints = App.Data.getConfiguration('breakpoints');

        App.Media = {};
        App.Media.minWidth = screen => this.minWidth(screen);
        App.Media.maxWidth = screen => this.maxWidth(screen);
    }

    getWidth(screen) {
        if (screen === 'xl') return 2500; //@todo: find a solution for this
        return this.breakpoints['screen-' + screen].width;
    }

    getFromWidth(width) {
        let breakpoint = '';
        for (let key in this.breakpoints) {
            if (!breakpoint && width <= this.breakpoints[key].width) breakpoint = key;
        }
        breakpoint = breakpoint ? breakpoint : 'screen-xl' ;
        return breakpoint.replace('screen-', '');
    }

    // screen media
    minWidth(screen) {
        return this.getWidth(screen) <= window.innerWidth;
    }

    // screen media
    maxWidth(screen) {
        return this.getWidth(screen) >= window.innerWidth;
    }
}

App.Interface.Breakpoint = new Breakpoint();